import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import styled from "styled-components";
import axios from "axios";
import get from "lodash/get";
import {
  GlobalSettingsContext,
  GlobalSettingsProvider,
} from "./contexts/globalSettings";
import Button from "./components/Button/Button";
import useScroll from "./hooks/useScroll";
import Tabs from "./components/Tabs/Tabs";
import MainTab from './components/Tabs/views/Main';
// import HistoryTab from './components/Tabs/views/History';
import SettingsTab from "./components/Tabs/views/Settings";
// import AnalyticsTab from './components/Tabs/views/Analytics';
import PianoTab from "./components/Tabs/views/Piano";
import SlideIn from "./components/SlideIn/SlideIn";
import PopOutPortal from "./components/PopOutPortal/PopOutPortal";

const AppContainer = styled.div`
  &.jibboo_debug__app {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 999999;

    #button-container {
      z-index: 1;
    }

    &--portal-open {
      top: 0;
      left: 0;
      position: relative;
      width: 100%;
      height: auto;
      margin-bottom: 65px;

      .tab-content {
        height: auto;
        width: 100%;

        .tab-content__holder {
          overflow: hidden;
          height: auto;
        }
      }

      #button-container {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
      }
    }
  }
`;

let trackingInterval; // Setup a tracking Interval

const App = () => {
  // const { info, setInfo, getItem } = useContext(GlobalSettingsContext);
  const info = {};
  const { scrollDirection, scrollY } = useScroll();
  const [slideIns, setSlideIns] = useState([]);
  const [trackingEnabled, setTrackingEnabled] = useState(false);
  const [showWindowPortal, setShowWindowPortal] = useState(false);
  const initialRender = useRef(true);
  const slideInElements = useRef([]);

  const postToTempo = () => {
    const timestamp = Date.now();
    const payload = {
      //pageVisits: getItem('pageVisits'),
    };
    const objectSentToTempo = {
      url: window.location.pathname,
      eventname: "user-interval",
      //ufp: `${getItem('ufp')}:${timestamp}`,
      payload: JSON.stringify(payload),
    };

    axios
      .post("https://tempo.inc.com/jj/add", objectSentToTempo)
      .then((response) => {
        console.log("🔶 Insertion Response:", "\n", response);
      });
  };

  useEffect(() => {
    // Append vists to `pageVisits` array on PAGE LOAD
    handleInitialPageLoad();

    // Listen for title tag change, for SPA tracking
    listenForElementMutation("title");
  }, []); // eslint-disable-line

  /**
   * Listen for changes to Session Info
   */
  useEffect(() => {
    checkLimitReached();
  }, [info.sessionInfo]);

  const handleInitialPageLoad = () => {
    // const { target, timeStamp } = loadEvent;
    // let currentInfo = { ...info };
    // let oldVisits = currentInfo.pageVisits;
    // let isUnique = isUniquePageView();
    // let viewLimit = get(currentInfo, 'sessionInfo.uniquePageLimit', '');
    // let uniquePagesLeft = get(currentInfo, 'sessionInfo.uniquePagesLeft', viewLimit);
    // let uniqueViews =  [...new Set(get(currentInfo, 'pageVisits', []).map(item => item.location))];
    // let currentDate = Date.now();
    // // add new visit to array
    // oldVisits.push({
    //   label: new Date(currentDate).toLocaleString('en-US', { hour12: true }),
    //   name: target.title || document.title || 'Default Page Visit',
    //   location: get(target, 'location.pathname', 'Unknown Location'),
    //   date: Date.now(),
    //   timeStamp: timeStamp,
    // });
    // let pageVisitObject = {
    //   pageVisits: oldVisits,
    // }
    // if(isUnique) {
    //   pageVisitObject.sessionInfo = Object.assign({}, currentInfo.sessionInfo, {
    //     uniquePagesLeft: uniquePagesLeft !== '' ? uniquePagesLeft - 1 : viewLimit,
    //     totalUniqueViews: uniqueViews.length + 1,
    //   });
    // }
    // setInfo(pageVisitObject);
  };

  const trackNewPageView = () => {
    // let currentInfo = JSON.parse(localStorage.getItem('_jjdebug_global_settings'));
    let oldVisits = currentInfo.pageVisits;
    let isUnique = isUniquePageView();
    let viewLimit = get(currentInfo, "sessionInfo.uniquePageLimit", "");
    let uniquePagesLeft = get(
      currentInfo,
      "sessionInfo.uniquePagesLeft",
      viewLimit
    );
    let uniqueViews = [
      ...new Set(
        get(currentInfo, "pageVisits", []).map((item) => item.location)
      ),
    ];
    let currentDate = Date.now();

    // add new visit to array
    oldVisits.push({
      label: new Date(currentDate).toLocaleString("en-US", { hour12: true }),
      name: document.title || "Default Page Visit",
      location: get(window, "location.pathname", "Unknown Location"),
      date: currentDate,
    });

    let pageVisitObject = {
      pageVisits: oldVisits,
    };

    if (isUnique) {
      pageVisitObject.sessionInfo = Object.assign({}, currentInfo.sessionInfo, {
        uniquePagesLeft:
          uniquePagesLeft !== "" ? uniquePagesLeft - 1 : viewLimit,
        totalUniqueViews: uniqueViews.length + 1,
      });
    }

    // setInfo(pageVisitObject);
  };

  /**
   * Listen for `mousedown` event (i.e. click)
   */
  useEffect(() => {
    document.addEventListener("mousedown", (event) => {
      let clickTargetNodeName = event.target.nodeName;
      let clickTargetOuterHtml = event.target.outerHTML;

      // setInfo({
      //   type: 'append',
      //   key: 'sessionEvents',
      //   data: {
      //     type: 'mousedown',
      //     clickTargetNodeName,
      //     clickTargetOuterHtml,
      //   }
      // });
    });

    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", (event) => {});
    };
  }, []);

  const trackInterval = () => {
    console.log("%c>>> TRACKED STATE", "color: green;", {
      // page: get(JSON.parse(localStorage.getItem('_jjdebug_global_settings')), 'pageVisits[0]', {}),
    });

    postToTempo();
  };

  const startIntervalTracking = () => {
    trackingInterval = setInterval(() => {
      trackInterval();
    }, 2000);
  };

  const stopIntervalTracking = () => {
    clearInterval(trackingInterval);
  };

  /**
   * Handle interval tracking for users when enabled
   */
  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }

    if (trackingEnabled) {
      // Start interval tracking, tracking is ON
      startIntervalTracking();
    } else {
      // Clear any intervals, tracking is OFF
      stopIntervalTracking();
    }
    return () => {
      clearInterval(trackingInterval);
    };
  }, [trackingEnabled]);

  /**
   * Listen for scroll events
   */
  useEffect(() => {
    // setInfo({
    //   type: 'append',
    //   key: 'sessionEvents',
    //   data: {
    //     type: 'scroll',
    //     direction: scrollDirection,
    //   }
    // });
  }, [scrollDirection, scrollY]);

  const isUniquePageView = () => {
    let currentInfo = { ...info };

    return (
      get(currentInfo, "pageVisits", []).filter((view) => {
        return view.location === get(window, "location.pathname");
      }).length <= 0
    );
  };

  const checkLimitReached = () => {
    let currentInfo = { ...info };
    let viewLimit = get(currentInfo, "sessionInfo.uniquePageLimit", null);
    let totalUniques = get(currentInfo, "sessionInfo.totalUniqueViews", null);

    if (viewLimit && viewLimit !== "" && totalUniques > viewLimit) {
      alert("Sorry! You have reached the view limit...please subscribe!");
    } else {
      /**
       * Page view allowed
       * Either the view limit has not been met, or this is non-unique page view
       */
    }
  };

  const listenForElementMutation = (element) => {
    new MutationObserver(function (mutations) {
      let currentInfo = { ...info };
      trackNewPageView(currentInfo);
    }).observe(document.querySelector(element), {
      subtree: true,
      characterData: true,
      childList: true,
    });
  };

  const togglePopOutWindow = () => {
    setShowWindowPortal(!showWindowPortal);
  };

  const closePopOutWindowRoot = () => {
    setShowWindowPortal(false);
  };

  const addSlideIn = () => {
    // setSlideIns([{title: 'Test Slide-In'}])
    setSlideIns([...slideIns, { title: "Test Slide-In" }]);
  };

  // useEffect(() => {
  //   // {items.map(item => (
  //   // <p key={item} ref={(element) => itemEls.current.push(element)}>{item}</p>
  //   // ))
  //   setSlideIns([...slideIns, {title: 'Test Slide-In'}])
  // }, [slideIns])

  return (
    <GlobalSettingsProvider>
      <Fragment>
        {slideIns.map((slide) => (
          <SlideIn {...slide} />
        ))}
        {/* ------------------------------ THE IN-PAGE DEBUG ELEMENT ------------------------------  */}
        {!showWindowPortal && (
          <AppContainer className="jibboo_debug__app">
            <Tabs>
              <div label="Main"> 
                <MainTab />
              </div>
              {/* <div label="Analytics"> 
                <AnalyticsTab />
              </div>
              <div label="History"> 
                <HistoryTab />
              </div> */}
              <div label="Piano">
                <PianoTab />
              </div>
              <div label="Settings">
                <SettingsTab />
              </div>
              {/* <div>hiya</div> */}
            </Tabs>
            <div
              id="button-container"
              style={{ background: "linear-gradient(0.01deg, #ccc, #fff)" }}
            >
              {/* <Button
                onClick={() => {
                  addSlideIn();
                }}
              >
                Test Slide-In
              </Button> */}
              
              <Button
                className="debugButton"
                onClick={() => {
                  togglePopOutWindow();
                }}
              >
                {showWindowPortal ? "Close the" : "Open as "} window
              </Button>

              {/* <Button
                onClick={() => {
                  postToTempo();
                }}
              >
                Manual Save
              </Button> */}

              {/* <Button
                onClick={() => {
                  setTrackingEnabled(!trackingEnabled);
                }}
                activeBgColor={trackingEnabled && "green"}
              >
                Hot Tracking: {trackingEnabled ? "enabled" : "disabled"}
              </Button> */}
            </div>
          </AppContainer>
        )}
        {/* ------------------------------ THE PORTAL DEBUG ELEMENT ------------------------------  */}
        {showWindowPortal && (
          <PopOutPortal onUnload={closePopOutWindowRoot}>
            <AppContainer className="jibboo_debug__app jibboo_debug__app--portal-open">
              <Tabs>
                <div label="Main"> 
                  <MainTab />
                </div>
                {/* <div label="Analytics"> 
                  <AnalyticsTab />
                </div>
                <div label="History"> 
                  <HistoryTab />
                </div> */}
                <div label="Piano">
                  <PianoTab />
                </div>
                <div label="Settings">
                  <SettingsTab />
                </div>
                {/* <div>biya</div> */}
              </Tabs>
              <div
                id="button-container"
                style={{ background: "linear-gradient(0.01deg, #ccc, #fff)" }}
              >
                {/* <Button
                  onClick={() => {
                    addSlideIn({ title: "Test Slide-In" });
                  }}
                >
                  Test Slide-In
                </Button> */}

                <Button
                  className="debugButton"
                  onClick={() => {
                    closePopOutWindowRoot();
                  }}
                >
                  {showWindowPortal ? "Close the" : "Open as "} window
                </Button>

                {/* <Button
                  onClick={() => {
                    postToTempo();
                  }}
                >
                  Manual Save
                </Button> */}

                {/* <Button
                  onClick={() => {
                    setTrackingEnabled(!trackingEnabled);
                  }}
                  activeBgColor={trackingEnabled && "green"}
                >
                  Hot Tracking: {trackingEnabled ? "enabled" : "disabled"}
                </Button> */}
              </div>
            </AppContainer>
          </PopOutPortal>
        )}
      </Fragment>
    </GlobalSettingsProvider>
  );
};

export default App;
